import { observer } from 'mobx-react';

import { Button } from 'react-bootstrap';
import * as style from './NewDealNoPDF.module.less';
import { useStore, useStoreUI } from '@assets/model/Store';
import { ModalNewResearch } from '../ModalNewResearch/ModalNewResearch';

export const NewDealNoPDF = observer(() => {
    const onClick = () => {
        const store = useStoreUI();
        store.modal = {
            title: 'New Case',
            el: <ModalNewResearch />
        };
    };
    return (
        <Button
            variant="light"
            className={style.newDealButton}
            onClick={onClick}
        >
            <i className={`bi bi-plus-lg ${style.plusIcon}`}></i>
            New Case
        </Button>
    );
});
